export interface SkuStatusLabelUiText {
  newArrivalRequest: string
  restockRequest: string
  comingSoon: string
  soldOut: string
}

interface SkuStatusLabelUiTextEnvironment {
  readonly isLikeHotellovers: boolean
}

export const defaultSkuStatusLabelUiText: SkuStatusLabelUiText = {
  newArrivalRequest: '新作リクエスト',
  restockRequest: '再入荷リクエスト',
  comingSoon: '入荷待ち',
  soldOut: 'Sold Out',
}

const hotelloversSkuStatusLabelUiText: SkuStatusLabelUiText = {
  ...defaultSkuStatusLabelUiText,
  newArrivalRequest: '入荷通知',
  restockRequest: '再入荷通知',
}

export function createSkuStatusLabelUiText(
  environment: SkuStatusLabelUiTextEnvironment
): SkuStatusLabelUiText {
  if (environment.isLikeHotellovers) {
    return hotelloversSkuStatusLabelUiText
  }

  return defaultSkuStatusLabelUiText
}
